import { AdminDashboardFilterValues } from "./admin-dashboard-filter-panel";

export type PayoutStatus = "Paid" | "Pending" | "Cancelled";
export type SortDirection = "asc" | "desc";

export type AdminTableSortKey =
  | "partnerName"
  | "orderNumber"
  | "orderValue"
  | "partnerEarnings"
  | "afpEarnings"
  | "payoutStatus";

export interface AdminEarningRow {
  orderId: number;
  partnerName: string;
  orderNumber: string;
  orderValue: string;
  partnerEarnings: string;
  afpEarnings: string;
  payoutStatus: PayoutStatus;
}

export interface SessionTokenShape {
  accessToken?: string;
  token?: string;
  data?: {
    accessToken?: string;
    token?: string;
  };
}


export function getAdminEarningsHeaders(partnerType: "provider" | "planner") {
  return [
    {
      key: "partnerName",
      label: partnerType === "planner" ? "PRENEED PLANNER NAME" : "PROVIDER NAME",
    },
    { key: "orderNumber", label: "ORDER NUMBER" },
    { key: "orderValue", label: "ORDER VALUE" },
    {
      key: "partnerEarnings",
      label: partnerType === "planner" ? "PRENEED PLANNER EARNINGS" : "PROVIDER EARNINGS",
    },
    { key: "afpEarnings", label: "AFP EARNINGS" },
    { key: "payoutStatus", label: "PAYOUT STATUS" },
  ];
}

export const DEFAULT_ADMIN_FILTERS: AdminDashboardFilterValues = {
  all: true,
  provider: false,
  preneedPlanner: false,
  providerSearch: "",
  preneedPlannerSearch: "",
};
